import axios from 'axios';

const sleep = ms => {
  return new Promise(resolve => setTimeout(resolve, ms));
};

export default class IubendaCookieSolution {
  constructor(hasIubendaCookieSolution, iubendaApiKey) {
    this._iub = window._iub;
    this._hasIubendaCookieSolution = hasIubendaCookieSolution;
    this._iubendaApiKey = iubendaApiKey;
  }

  async isConsentGiven() {
    // se non ha attivo il modulo di iubenda ritorno true, altrimenti controllo se ha dato l'autorizzazione
    if (!this._hasIubendaCookieSolution) return true;

    if (!!window._iub && !!window._iub.cs) {
      return window._iub.cs.api.isConsentGiven();
    }

    // se non è presente provo ad aspettare ancora un attimo nel caso in cui non si sia ancora caricato e riprovo
    await sleep(1000);

    if (!!window._iub && !!window._iub.cs) {
      return window._iub.cs.api.isConsentGiven();
    }

    return false;
  }

  async proceedIfHasConsent(callback) {
    if (await this.isConsentGiven()) {
      return callback();
    } else {
      return null;
    }
  }

  async renderIfHasConsent(component) {
    if (await this.isConsentGiven()) {
      return component;
    } else {
      return null;
    }
  }

  async saveConsentSignUp(user, form) {
    try {
      if (this._iubendaApiKey) {
        const url = 'https://consent.iubenda.com/consent';
        const ip_address = await this._getIpAddress()

        const consentObj = {
          subject: {
            id: user.id,
            email: user.email,
            first_name: user.billing.firstname,
            last_name: user.billing.lastname,
            full_name: user.billing.firstname + ' ' + user.billing.lastname,
            verified: false,
          },
          legal_notices: [
            {
              identifier: 'privacy_policy',
            },
            {
              identifier: 'cookie_policy',
            },
          ],
          proofs: [
            {
              content: 'form_signup',
              form,
            },
          ],
          preferences: {
            privacy_policy: user.hasAcceptedPrivacyPolicy,
            cookie_policy: user.hasAcceptedPrivacyPolicy,
            newsletter: !!user.hasSubscribedToNewsletter,
          },
          ip_address,
        };

        const result = await axios({
          url,
          method: 'POST',
          headers: {
            ApiKey: this._iubendaApiKey,
          },
          data: consentObj,
        });

        return result;
      }
    } catch (err) {
      console.error('Error while saving consent on Iubenda');
    }
  }

  async saveConsentNewsletter(email) {
    try {
      if (this._iubendaApiKey) {
        const url = 'https://consent.iubenda.com/consent';
        const ip_address = await this._getIpAddress();

        const form = this._getForm('form_newsletter', {
          email,
          hasSubscribedToNewsletter: true,
        });

        let consentObj = {
          subject: {
            email,
            verified: false,
          },
          proofs: [
            {
              content: 'form_newsletter',
              form,
            },
          ],
          preferences: {
            newsletter: true,
          },
          ip_address,
        };

        const result = await axios({
          url,
          method: 'POST',
          headers: {
            ApiKey: this._iubendaApiKey,
          },
          data: consentObj,
        });

        return result;
      }
    } catch (err) {
      console.error('Error while saving consent on Iubenda', err);
    }
  }

  _getForm(id, obj) {
    let form;
    try {
      form = window.document.getElementById(id);

      if (form) {
        form = form.outerHTML;
        return form;
      }
    } catch (err) {
      console.error('Errore getting form');
    }
    return JSON.stringify(obj);
  }

  async _getIpAddress() {
    try {
      const ip_address_obj = await axios({
        url: 'https://geolocation-db.com/json/',
        method: 'GET',
      });
      return ip_address_obj?.data?.IPv4;
    } catch (err) {
      console.error('Error getting ip address for iuenda consent solution', err)
      return null
    }
  }
}
